import type { DiscoveryGetTrends200PageAllOfThreeContentItemAuth } from './discoveryGetTrends200PageAllOfThreeContentItemAuth';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfo } from './discoveryGetTrends200PageAllOfThreeContentItemBasicInfo';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContent } from './discoveryGetTrends200PageAllOfThreeContentItemContent';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemStats } from './discoveryGetTrends200PageAllOfThreeContentItemStats';

export type DiscoveryGetTrends200PageAllOfThreeContentItem = {
  /** 인증 컨텍스트 정보 */
  auth?: DiscoveryGetTrends200PageAllOfThreeContentItemAuth;
  basicInfo?: DiscoveryGetTrends200PageAllOfThreeContentItemBasicInfo;
  /** 트렌드 관련 콘텐츠 */
  content?: DiscoveryGetTrends200PageAllOfThreeContentItemContent;
  /** 트렌드 통계 정보 */
  stats?: DiscoveryGetTrends200PageAllOfThreeContentItemStats;
};
